import { TimeScaleFilter } from '../types';
import { add, format, isAfter, isBefore, Locale, set } from 'date-fns';

type Params = {
  scaleFilter: TimeScaleFilter;
  loadDaysBuffer: number;
  startDate: Date;
  adapterLocale?: Locale;
  offset?: number;
};

const SINGLE_ENTRY_ELEMENTS_AMOUNT = 24;
const TITLE_FORMAT = 'd MMMM y';
const DATE_FORMAT = 'p';

export const generateTimeSeries = ({
  scaleFilter: { measureScale, measureType },
  loadDaysBuffer,
  startDate,
  adapterLocale,
  offset = 0,
}: Params) => {
  if (measureType === 'months') {
    return {
      timeSeries: Array.from({ length: 12 }).map((_, monthIndex) => {
        const month = set(new Date(), {
          month: monthIndex,
          hours: 0,
          minutes: 0,
          seconds: 0,
          milliseconds: 0,
          date: 1,
        });

        const isCurrent = month.getMonth() === new Date().getMonth();
        return {
          title: format(month, 'LLLL', { locale: adapterLocale }),
          elements: Array.from({ length: 1 }).map(() => {
            return { label: '', direction: null, value: set(new Date(), { month: month.getMonth() }), isCurrent };
          }),
        };
      }),
    };
  }

  return {
    timeSeries: Array.from({ length: loadDaysBuffer }).map((_, dayIndex, dayArr) => {
      const currentDate = add(startDate, { days: dayIndex });
      const isLastDay = dayIndex === dayArr.length - 1;
      const isFirstDay = dayIndex === 0;
      return {
        title: format(currentDate, TITLE_FORMAT, { locale: adapterLocale }),
        elements: Array.from({ length: SINGLE_ENTRY_ELEMENTS_AMOUNT / measureScale }).map((_, scaleIndex, scaleArr) => {
          const canAddRef = Math.ceil(scaleArr.length / 4) === scaleIndex;
          const incrementedValue = scaleIndex * measureScale;
          const duration = { [measureType]: incrementedValue };
          const currentValue = add(currentDate, duration);
          const isCurrentDate =
            isAfter(add(currentValue, { [measureType]: measureScale }), new Date()) &&
            isBefore(currentValue, new Date());
          return {
            label: format(add(currentValue, { hours: offset }), DATE_FORMAT, { locale: adapterLocale }),
            direction: canAddRef ? (isLastDay ? 'right' : isFirstDay ? 'left' : null) : null,
            value: currentValue,
            isCurrent: isCurrentDate,
          };
        }),
      };
    }),
  };
};
